import {
  initFooter,
  initLangAction,
  initLangCookie,
  initResponsivecMenu,
} from "./common";

var lang;
$(document).ready(function () {
  $(function () {
    initFooter();
    initLangUi();
    initLs();
  });
});

function initLangUi() {
  lang = initLangCookie();
  console.log("about: lang = " + lang);

  initLangAction();
}

function initLs() {
  const popupOverlay = document.getElementById("popUpOverlay");
  const closePopupBtn = popupOverlay.querySelector(".btn-close-popup");
  var btnReadMore = document.getElementById("btnReadMore");

  closePopupBtn.addEventListener("click", function () {
    popupOverlay.style.display = "none";
  });
  btnReadMore.addEventListener("click", function () {
    initCeoReadMore();
  });
  initResponsivecMenu();
  initReadMore();
}

function initCeoReadMore() {
  console.log("initceoReadMore");
  const ceoContainer = document.querySelectorAll(".grid-2")[0];
  const popupOverlay = document.getElementById("popUpOverlay");
  const popupContent = document.getElementById("popUpContent");
  const popupTitle = popupOverlay.querySelector("h3");

  const name = ceoContainer.querySelector("h3").innerText;
  const aboutText = ceoContainer.querySelector(".about").innerHTML;
  popupTitle.innerText = name;
  popupContent.innerHTML = aboutText;
  popupOverlay.style.display = "flex";
}

function initMoreLess() {
  var dots = document.getElementById("dots");
  var moreText = document.getElementById("more");
  var btnReadMore = document.getElementById("btnReadMore");

  if (dots.style.display === "none") {
    dots.style.display = "inline";
    btnReadMore.innerHTML = "Read more";
    moreText.style.display = "none";
  } else {
    dots.style.display = "none";
    btnReadMore.innerHTML = "Read less";
    moreText.style.display = "inline";
  }
}

function initReadMore() {
  const containers = document.querySelectorAll(".grid-2-res .team-member");
  const popupOverlay = document.getElementById("popUpOverlay");
  const popupContent = document.getElementById("popUpContent");
  const popupTitle = popupOverlay.querySelector("h3");

  containers.forEach((container) => {
    const moreContent = container.querySelector(".more");
    const readMoreBtn = container.querySelector(".btnMore");
    const name = container.querySelector("h3").innerText;
    const aboutText = container.querySelector(".about").innerHTML;
    if (moreContent && readMoreBtn) {
      readMoreBtn.addEventListener("click", function () {
        popupTitle.innerText = name;
        popupContent.innerHTML = aboutText;
        popupOverlay.style.display = "flex";
      });
    }
  });
}
